import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../../../hooks/hooks";
const ProtectedRoute = () => {
  const { loggedIn } = useAppSelector((state: any) => state.authentication);
  return loggedIn ? <Outlet /> : <Navigate to="/login" />;
};
export default ProtectedRoute;
